import { render, staticRenderFns } from "./ListNotAllowed.vue?vue&type=template&id=43d33f4c&lang=html&"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports